import { Col, Row, Spinner, Stack } from 'react-bootstrap';

import {
  faCheckCircle,
  faXmarkCircle,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { BackendStatusData } from 'src/models/GalenData/BackendStatus.model';
import { ModelStatus } from 'src/models/GalenData/DeviceDataView.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

const modelNameObject: Record<
  keyof Omit<BackendStatusData, 'GlobalStatus' | 'SessionId'>,
  string
> = {
  DrusStatus: 'Diabetic Retinopathy',
  DreuStatus: 'Diabetic Retinopathy',
  AmdeuStatus: 'Age-related Macular Degeneration',
  GlaucomaeuStatus: 'Glaucoma',
  CvdeuStatus: 'Cardiovascular Disease',
  CvdauStatus: 'Cardiovascular Disease (AU)',
  DreuSmallStatus: 'Diabetic Retinopathy',
  AmdeuSmallStatus: 'Age-related Macular Degeneration',
  GlaucomaeuSmallStatus: 'Glaucoma',
  CvdeuSmallStatus: 'Cardiovascular Disease',
  CvdauSmallStatus: 'Cardiovascular Disease (AU)',
  VesselSegStatus: 'Vessel Segmentation',
};

const modelStatusObject: Record<ModelStatus, string> = {
  [ModelStatus.NA]: 'Awaiting Upload',
  [ModelStatus.Triggered]: 'Queued',
  [ModelStatus.Running]: 'Running',
  [ModelStatus.Complete]: 'Complete',
  [ModelStatus.Failed]: 'Failed',
};

const ModelStack = ({
  name,
  status,
}: {
  name: keyof Omit<BackendStatusData, 'GlobalStatus' | 'SessionId'>;
  status: BackendStatusData;
}) => {
  const statusValue = status[name]?.value ?? ModelStatus.NA;

  const { tCommon } = useUiTranslation();

  return (
    <Stack gap={3}>
      <Row>
        <Col sm={9}>
          {statusValue === ModelStatus.Complete ? (
            <FontAwesomeIcon icon={faCheckCircle} className="text-primary" />
          ) : statusValue === ModelStatus.Failed ? (
            <FontAwesomeIcon icon={faXmarkCircle} className="text-danger" />
          ) : (
            <Spinner variant="primary" size="sm" />
          )}
          <span className="ms-3">
            {tCommon(`server.modelNameObject.${modelNameObject[name]}`)}
          </span>
        </Col>

        <Col
          sm={3}
          className={`${statusValue === ModelStatus.Failed ? 'text-danger' : 'text-gray-400'} text-end`}
        >
          {tCommon(
            `server.modelStatusObject.${modelStatusObject[statusValue]}`,
          )}
        </Col>
      </Row>
    </Stack>
  );
};

export default ModelStack;
